import type { PdfDocumentObject, PdfEngine } from "@embedpdf/models";
import { PdfPageFlattenResult } from "@embedpdf/models";

/** Export a private static copy, keeping the live editable document intact. */
export async function exportStaticPdf(
  engine: PdfEngine<Blob>,
  document: PdfDocumentObject,
): Promise<Uint8Array> {
  const content = await engine.extractPages(document, document.pages.map((page) => page.index)).toPromise();
  const copy = await engine.openDocumentBuffer({ id: `static-export-${crypto.randomUUID()}`, content }).toPromise();
  try {
    for (const page of copy.pages) {
      const result = await engine.flattenPage(copy, page).toPromise();
      if (result === PdfPageFlattenResult.Fail) throw new Error(`Could not flatten page ${page.index + 1}.`);
    }
    return new Uint8Array(await engine.saveAsCopy(copy).toPromise());
  } finally {
    await engine.closeDocument(copy).toPromise();
  }
}

/** A positive marker flags hybrid XFA PDFs; absence does not certify their format. */
export function hasXfaMarker(bytes: Uint8Array): boolean {
  return /\/XFA\b/.test(new TextDecoder("latin1").decode(bytes));
}
